import { render } from "./ContactModal.vue?vue&type=template&id=b2b0b0e2&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=b2b0b0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b0b0e2"]])

export default __exports__